module.exports = __webpack_public_path__ + "img/x-octagon.ebb0530a.svg";